import { rootDomainCookie, TRADEIN_ESTIMATE_COOKIE_NAME } from '@beef/shop-common';
import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { captureException } from '@sentry/react';

import pushEvent, { SELECT_TRADE_IN_DEVICE_TYPE } from 'pushEvent/index';
import { fetchTradeInDeviceBrands } from 'store/widgets/TradeInNewCalculator/brand/actions';
import { selectDataForTradeInAnalytics } from 'store/widgets/TradeInNewCalculator/common/analytics-selectors';
import { DeviceType } from 'store/widgets/TradeInNewCalculator/deviceType';

import { api } from '../../../../api';

export const setTradeInDeviceType = createAction<string>('tradeId/setDeviceType');

export const fetchTradeInDeviceTypes = createAsyncThunk(
  'tradeId/fetchDeviceTypes',
  async (): Promise<DeviceType[]> => {
    const result = await api.fetchDeviceTypes();

    return result?.data?.deviceTypes;
  },
);

export const setDeviceTypeAndFetchBrands = createAsyncThunk(
  'tradeId/setDeviceTypeAndFetchBrands',
  async (deviceType: string, { getState, dispatch }): Promise<string> => {
    dispatch(setTradeInDeviceType(deviceType));

    try {
      await dispatch(fetchTradeInDeviceBrands(deviceType)).unwrap();
      rootDomainCookie.remove(TRADEIN_ESTIMATE_COOKIE_NAME);
      pushEvent(SELECT_TRADE_IN_DEVICE_TYPE, selectDataForTradeInAnalytics(getState()));

      return deviceType;
    } catch (e) {
      captureException(e);
    }
  },
);
